import { get, http } from '@/api/request'

export default {

  loadPath: (data, success, failure) => {
    return get(
      'api' + data.path,
      response => success(response),
      error => failure(error),
      {
        params: data.params
      }
    )
  },

  downloadFromPath: (path, success, failure) => {
    return http({
        method: 'get',
        url: 'api' + path,
        responseType: 'blob'
      }
    ).then(response => success(response))
    .catch(error => failure(error))
  },

  downloadFromPathByDate: (payload, success, failure) => {
    return http({
        method: 'get',
        url: 'api' + payload.path,
        params: payload.data,
        responseType: 'blob'
      }
    ).then(response => success(response))
    .catch(error => failure(error))
  },

  // Move this.
  loadPriorities: (success, failure) => get(
    '/api/priorities',
    response => success(response),
    error => failure(error)
  )
}